import Resizer from 'react-image-file-resizer'

export function useResizeImage() {
  function resizeFileAndTransformToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const objectUrl = URL.createObjectURL(file)
      const probe = new Image()
      probe.onload = () => {
        URL.revokeObjectURL(objectUrl)
        Resizer.imageFileResizer(
          file,
          1000,
          1000,
          'JPEG',
          100,
          0,
          (uri) => resolve(uri as string),
          'base64'
        )
      }
      probe.onerror = () => {
        URL.revokeObjectURL(objectUrl)
        reject(new Error('unsupported_image_format'))
      }
      probe.src = objectUrl
    })
  }

  return { resizeFileAndTransformToBase64 }
}
